import _taggedTemplateLiteral from "@babel/runtime/helpers/esm/taggedTemplateLiteral";

function _templateObject5() {
  var data = _taggedTemplateLiteral(["\n    font-size: 14px;\n    color: ", ";\n"]);

  _templateObject5 = function _templateObject5() {
    return data;
  };

  return data;
}

function _templateObject4() {
  var data = _taggedTemplateLiteral(["\n    font-size: 16px;\n    color: ", ";\n"]);

  _templateObject4 = function _templateObject4() {
    return data;
  };

  return data;
}

function _templateObject3() {
  var data = _taggedTemplateLiteral(["\n    display: flex;\n    padding: 4px 12px;\n    align-items: center;\n"]);

  _templateObject3 = function _templateObject3() {
    return data;
  };

  return data;
}

function _templateObject2() {
  var data = _taggedTemplateLiteral(["\n    width: 100%;\n    height: 100%;\n    color: ", ";\n"]);

  _templateObject2 = function _templateObject2() {
    return data;
  };

  return data;
}

function _templateObject() {
  var data = _taggedTemplateLiteral(["\n    span {\n        background-color: transparent;\n    }\n"]);

  _templateObject = function _templateObject() {
    return data;
  };

  return data;
}

import styled from 'styled-components';
import AvatarMenu from 'react-rainbow-components/components/AvatarMenu';
import Avatar from '../../icons/Avatar';
export var UserAvatar = styled(AvatarMenu)(_templateObject());
export var AvatarIcon = styled(Avatar)(_templateObject2(), function (props) {
  return props.theme.rainbow.palette.brand.main;
});
export var UserInfo = styled.li(_templateObject3());
export var UserName = styled.h2(_templateObject4(), function (props) {
  return props.theme.rainbow.palette.text.main;
});
export var UserDescription = styled.h2(_templateObject5(), function (props) {
  return props.theme.rainbow.palette.text.header;
});